let cookieConsentModulePromise;

// Keep the event entry file tiny and load the full runtime only when needed.
async function loadCookieConsent() {
	if (!cookieConsentModulePromise) {
		cookieConsentModulePromise = import("./cookie-consent.js");
	}
	return cookieConsentModulePromise;
}

export function cookieConsentEvents() {
	const root = document.querySelector("[data-cookie-consent]");
	const triggers = Array.from(document.querySelectorAll("[data-cookie-consent-open]"));

	if (!root && !triggers.length) {
		return;
	}

	// If the banner is rendered, initialize immediately so the runtime can
	// decide whether to show the first-visit banner or the saved-choices button.
	if (root) {
		loadCookieConsent()
			.then(({ initCookieConsent }) => initCookieConsent(root, triggers))
			.catch((err) => console.error("Failed to load cookie consent:", err));
		return;
	}

	// Fallback path for pages that only expose an external privacy trigger.
	// Replay the first click after the dynamic import finishes.
	async function firstClick(event) {
		triggers.forEach((trigger) => trigger.removeEventListener("click", firstClick));
		try {
			const { initCookieConsent } = await loadCookieConsent();
			const api = initCookieConsent(root, triggers);
			if (api && typeof api.handleEvent === "function") {
				api.handleEvent(event);
			}
		} catch (err) {
			console.error("Failed to load cookie consent:", err);
		}
	}

	triggers.forEach((trigger) => trigger.addEventListener("click", firstClick));
}
